import useStore from '../../store/store';
import { Container, Row, Col } from 'react-grid-system'
import { useScreenClass } from 'react-grid-system';
const roundValue = (value) => {
	return +(Math.round(value + "e+1") + "e-1");
}

const OctaveMeasuredPanel = (
	{
		setinitialMeasurementDistance,
		bandSets,
		changeBandValue,
		totalSourceNoise,
		receiverNoiseLin,
		totalRecieverNoiceLin,
		measuredNoiseNoBarrierTotal,
		measuredNoiseNoBarrier,
		totalSourceNoiseDba
	}
) => {

	const barrierScenario = useStore((state) => state.scenario);
	// responsive component based the screen width
	const screenClass = useScreenClass();

	return (
		<>
			<div className="panel" id="measuredOctavesPanel" style={{ display: 'flex', flexFlow: 'column', height: '100%' }}>
				<Container >

					{/* top measurement distance */}
					<Col xs={12} style={{ marginBottom: '20px', paddingLeft: `${['sm', 'xs'].includes(screenClass) ? '0px' : 'auto'}` }}>
						<p style={{ display: 'flex', flexWrap: 'wrap', justifyContent: `${['sm', 'xs'].includes(screenClass) ? 'left' : 'center'}`, alignItems: 'baseline' }}>
							Measurement distance
							<label className="panel-number" style={{ display: 'flex', flexFlow: 'row', alignItems: 'center' }} >
								<input
									type="text"
									onChange={(e) => { setinitialMeasurementDistance(e.target.value) }}
								    defaultValue={10}
									style={{ marginTop: '0px' }}
									className="inner-panel-boxed-input user-input" ></input>m
							</label>
						</p>
					</Col>

					{/* octaves panel responsive small*/}
					{

						['sm', 'xs'].includes(screenClass) && (
							<>
								<Col xs={12} style={{ paddingLeft: '0px' }}>
									<div >Measured Sound Pressure (Linear)</div>
								</Col>
								<Row>
									<Col xs={12} style={{ display: 'inline-flex', marginTop: '10px', paddingLeft: '0px' }}>
										{Object.keys(bandSets).map((item, index) => {
											return (
												index <= 2 && (

													<>
														<label className="panel-number" key={"lbl1" + index}>
															{item.split('b')}
															<input key={index} className="inner-panel-boxed-input" defaultValue={bandSets[item]} onChange={(e) => { changeBandValue(e, item) }}></input>
														</label>
														{
															index === Object.values(bandSets).length - 1 && (
																<label className="panel-number" key={"unique" + index} >
																	dB(A):
																	<div className="output">
																		{roundValue(totalSourceNoise)}
																	</div>
																</label>
															)
														}
													</>
												)
											)
										})}
									</Col>
								</Row>
								<Row>
									<Col xs={12} style={{ display: 'inline-flex', marginTop: '10px', paddingLeft: '0px' }}>
										{Object.keys(bandSets).map((item, index) => {
											return (
												index > 2 && index <= 5 && (

													<>
														<label className="panel-number" key={"lbl1" + index}>
															{item.split('b')}
															<input key={index} className="inner-panel-boxed-input" defaultValue={bandSets[item]} onChange={(e) => { changeBandValue(e, item) }}></input>
														</label>
														{
															index === Object.values(bandSets).length - 1 && (
																<label className="panel-number" key={"unique" + index} >
																	dB(A):
																	<div className="output">
																		{roundValue(totalSourceNoise)}
																	</div>
																</label>
															)
														}
													</>
												)
											)
										})}
									</Col>
								</Row>
								<Row>
									<Col xs={12} style={{ display: 'inline-flex', marginTop: '10px', paddingLeft: '0px' }}>
										{Object.keys(bandSets).map((item, index) => {
											return (
												index > 5 && (

													<>
														<label className="panel-number" key={"lbl1" + index}>
															{item.split('b')}
															<input key={index} className="inner-panel-boxed-input" defaultValue={bandSets[item]} onChange={(e) => { changeBandValue(e, item) }}></input>
														</label>
														{
															index === Object.values(bandSets).length - 1 && (
																<label className="panel-number" key={"unique" + index} >
																	dB(A):
																	<div className="output">
																		{roundValue(totalSourceNoise)}
																	</div>
																</label>
															)
														}
													</>
												)
											)
										})}
									</Col>
								</Row>
							</>
						)
					}
					{/* octaves panel responsive big*/}
					{
						['md', 'lg', 'xl', 'xxl'].includes(screenClass) && (
							<>
								<Row>
									<Col xs={3} style={{ display: 'flex', alignItems: 'flex-end', paddingLeft: '0px' }}>
										<div >Measured Sound Pressure (Linear)</div>
									</Col>
									<Col xs={9} style={{ display: 'inline-flex', marginTop: '10px', paddingLeft: '0px' }}>
										{Object.keys(bandSets).map((item, index) => {
											return (
												<>
													<label className="panel-number" key={"lbl1" + index}>
														{item.split('b')}
														<input key={index} className="inner-panel-boxed-input" defaultValue={bandSets[item]} onChange={(e) => { changeBandValue(e, item) }}></input>
													</label>
													{
														index === Object.values(bandSets).length - 1 && (
															<label key={"unique" + index} >
																dB(A):
																<div className="output" style={{ marginTop: '10px' }}>
																	{roundValue(totalSourceNoiseDba)}
																</div>
															</label>
														)
													}
												</>
											)
										})}
									</Col>
								</Row>
							</>
						)
					}

					{/* end first octaves line */}
					{/* barriers line */}
					{
						['sm', 'xs'].includes(screenClass) && (
							<>
								<Col xs={12} style={{ display: 'flex', alignItems: 'flex-end', paddingLeft: '0px', marginTop: '20px' }}>
									<div>No Barriers <span className='text-italic'>A weighted</span></div>
								</Col>
								<Row>
									<Col xs={12} style={{ display: 'inline-flex', marginTop: '10px', paddingLeft: '0px' }}>
										{measuredNoiseNoBarrier.map((item, index) => {
											return (
												index <= 2 && (

													<>
														<div className='output'>
															{roundValue(item)}
														</div>
														{
															index === Object.values(measuredNoiseNoBarrier).length - 1 && (
																<div className='output'>
																	{roundValue(measuredNoiseNoBarrierTotal)}
																</div>
															)
														}
													</>
												)
											)
										})}
									</Col>
								</Row>
								<Row>
									<Col xs={12} style={{ display: 'inline-flex', marginTop: '10px', paddingLeft: '0px' }}>
										{measuredNoiseNoBarrier.map((item, index) => {
											return (
												index > 2 && index <= 5 && (

													<>
														<div className='output'>
															{roundValue(item)}
														</div>
														{
															index === Object.values(measuredNoiseNoBarrier).length - 1 && (
																<div className='output'>
																	{roundValue(measuredNoiseNoBarrierTotal)}
																</div>
															)
														}
													</>
												)
											)
										})}
									</Col>
								</Row>
								<Row>
									<Col xs={12} style={{ display: 'inline-flex', marginTop: '10px', paddingLeft: '0px' }}>
										{measuredNoiseNoBarrier.map((item, index) => {
											return (
												index > 5 && (

													<>
														<div className='output'>
															{roundValue(item)}
														</div>
														{
															index === Object.values(measuredNoiseNoBarrier).length - 1 && (
																<div className='output'>
																	{roundValue(measuredNoiseNoBarrierTotal)}
																</div>
															)
														}
													</>
												)
											)
										})}
									</Col>
								</Row>
							</>
						)
					}
					{/* barriers responsive big */}
					{
						['md', 'lg', 'xl', 'xxl'].includes(screenClass) && (
							<>
								<Row>

									<Col xs={3} style={{ display: 'flex', alignItems: 'flex-end', paddingLeft: '0px', marginTop: '20px' }}>
										<div style={{ paddingBottom: '10px' }}>No Barriers <span className='text-italic'>A weighted</span></div>
									</Col>
									{measuredNoiseNoBarrier.map((item, index) => {
										return (

											<>
												<div className='output'>
													{roundValue(item)}
												</div>
												{
													index === Object.values(measuredNoiseNoBarrier).length - 1 && (
														<div className='output'>
															{roundValue(measuredNoiseNoBarrierTotal)}
														</div>
													)
												}
											</>
										)
									})}
								</Row>
							</>
						)
					}
					{/* End no barriers line */}
					{/* Start With barriers */}
					{
						['sm', 'xs'].includes(screenClass) && (
							<>
								<Col xs={12} style={{ display: 'flex', alignItems: 'flex-end', paddingLeft: '0px', marginTop: '20px' }}>
									<div>Barriers <span className='text-italic'>A weighted</span></div>
								</Col>
								<Row>
									<Col xs={12} style={{ display: 'inline-flex', marginTop: '10px', paddingLeft: '0px' }}>
										{receiverNoiseLin.map((item, index) => {
											return (
												index <= 2 && (
													<>
														{
															barrierScenario !== 'noBarriers' && (
																<>
																	<div className='output'>
																		{roundValue(item)}
																	</div>
																</>
															)

														}
														{
															barrierScenario === 'noBarriers' && (
																<>
																	<div className='output'>
																		{''}
																	</div>
																	{
																		index === Object.values(receiverNoiseLin).length - 1 && (
																			<div className='output'>
																				{''}
																			</div>
																		)
																	}
																</>
															)

														}
													</>
												)
											)
										})}
									</Col>
								</Row>
								<Row>
									<Col xs={12} style={{ display: 'inline-flex', marginTop: '10px', paddingLeft: '0px' }}>
										{receiverNoiseLin.map((item, index) => {
											return (
												index > 2 && index <= 5 && (
													<>
														{
															barrierScenario !== 'noBarriers' && (
																<>
																	<div className='output'>
																		{roundValue(item)}
																	</div>
																	{
																		index === Object.values(receiverNoiseLin).length - 1 && (
																			<div className='output'>
																				{roundValue(totalRecieverNoiceLin)}
																			</div>
																		)
																	}
																</>
															)

														}
														{
															barrierScenario === 'noBarriers' && (
																<>
																	<div className='output'>
																		{''}
																	</div>
																	{
																		index === Object.values(measuredNoiseNoBarrier).length - 1 && (
																			<div className='output'>
																				{''}
																			</div>
																		)
																	}
																</>
															)

														}
													</>
												)
											)
										})}
									</Col>
								</Row>
								<Row>
									<Col xs={12} style={{ display: 'inline-flex', marginTop: '10px', paddingLeft: '0px' }}>
										{receiverNoiseLin.map((item, index) => {
											return (
												index > 5 && (
													<>
														{
															barrierScenario !== 'noBarriers' && (
																<>
																	<div className='output'>
																		{roundValue(item)}
																	</div>
																	{
																		index === Object.values(receiverNoiseLin).length - 1 && (
																			<div className='output'>
																				{roundValue(totalRecieverNoiceLin)}
																			</div>
																		)
																	}
																</>
															)

														}
														{
															barrierScenario === 'noBarriers' && (
																<>
																	<div className='output'>
																		{''}
																	</div>
																	{
																		index === Object.values(measuredNoiseNoBarrier).length - 1 && (
																			<div className='output'>
																				{''}
																			</div>
																		)
																	}
																</>
															)

														}
													</>
												)
											)
										})}
									</Col>
								</Row>
							</>
						)
					}
					{
						['md', 'lg', 'xl', 'xxl'].includes(screenClass) && (
							<>
								<Row>
									<Col xs={3} style={{ display: 'flex', alignItems: 'flex-end', paddingLeft: '0px' }}>
										<div style={{ paddingBottom: '10px' }}>Barriers <span className='text-italic'>A weighted</span></div>
									</Col>
									{receiverNoiseLin.map((item, index) => {
										return (

											<>
												{
													barrierScenario !== 'noBarriers' && (
														<>
															<div className='output'>
																{roundValue(item)}
															</div>
															{
																index === Object.values(receiverNoiseLin).length - 1 && (
																	<div className='output'>
																		{roundValue(totalRecieverNoiceLin)}
																	</div>
																)
															}
														</>
													)

												}
												{
													barrierScenario === 'noBarriers' && (
														<>
															<div className='output'>
																{''}
															</div>
															{
																index === Object.values(measuredNoiseNoBarrier).length - 1 && (
																	<div className='output'>
																		{''}
																	</div>
																)
															}
														</>
													)

												}
											</>
										)
									})}
								</Row>
							</>
						)
					}


				</Container>

			</div>
		</>
	)

}

export default OctaveMeasuredPanel;